import type { Theme } from '@mui/material';
import Grid from '@mui/material/Grid';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import type { StyleRules, WithStyles } from '@mui/styles';
import createStyles from '@mui/styles/createStyles';
import withStyles from '@mui/styles/withStyles';
import { HELPSITE_GIFT_USAGE_CHECK_DURATION_URL } from '../../common/constants';
import type {
  ReviewRequestMessagePropsMappedFromDispatch,
  ReviewRequestMessagePropsMappedFromState
} from '../../containers/project/ReviewRequestMessageContainer';

const styles = (theme: Theme): StyleRules =>
  createStyles({
    info: {
      padding: theme.spacing(),
      border: `solid 1px rgb(0, 151, 245)`,
      borderRadius: 5,
      backgroundColor: 'rgb(219, 241, 255)'
    },
    typography: {
      margin: `${theme.spacing(1)}`
    },
    section: {
      paddingTop: theme.spacing(3)
    }
  });

type ReviewRequestMessageProps = ReviewRequestMessagePropsMappedFromState &
  ReviewRequestMessagePropsMappedFromDispatch &
  WithStyles<typeof styles>;

const ReviewRequestMessage: React.FC<ReviewRequestMessageProps> = ({
  classes,
  selectedProject
}) => (
  <>
    {!selectedProject?.isAnyContentPartnerReviewRequested &&
      !selectedProject.isCancelled && (
        <section className={classes.section}>
          <Grid
            container
            item
            wrap="nowrap"
            alignItems="center"
            xs={12}
            className={classes.info}
          >
            <Typography
              variant="body2"
              color="textPrimary"
              className={classes.typography}
            >
              ギフトを利用するには審査が必要です。クリエイティブのご提出をお願いします。
              <br />
              掲載媒体や、デザインの内容によっては目安の審査日数よりも長く、審査のお時間をいただく場合があります。詳しくは
              <Link
                href={HELPSITE_GIFT_USAGE_CHECK_DURATION_URL}
                target="_blank"
                rel="noopener"
              >
                こちら
              </Link>
              をご確認ください。
            </Typography>
          </Grid>
        </section>
      )}
  </>
);

export default withStyles(styles)(ReviewRequestMessage);
